import * as z from 'zod';
export var patientInformationEventSchema = {
    data: z.object({
        volume: z.number().min(0).max(100),
        'hearing-loss': z.enum(['yes', 'no']).optional(),
        'headphone-check': z.enum(['left', 'right']).optional(),
        'birth-year': z.number().optional(),
        'gender-at-birth': z.enum(['male', 'female']).optional(),
        'perceived-hearing-loss': z
            .enum([
            'no-hearing-difficulties',
            'mild-hearing-loss',
            'moderate-hearing-loss',
            'severe-hearing-loss',
            'i-am-not-sure',
        ])
            .optional(),
    }),
};
